import * as React from "react";
import { QuestionsIF } from "../../QuestionsIF";
import { UnitConverter } from "./numericInput";
import { MeasurementUnits } from "fe-common/graphql";
import { GeneralNumericQuestion } from "./generalNumericQuestion";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface WeightQuestionProps extends QuestionsIF {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const ONE_LB_AS_KG = 0.45359237;

const weightUnitConverts: UnitConverter[] = [
  {
    unit: MeasurementUnits.Pounds,
    converters: [
      {
        from: MeasurementUnits.Kilograms,
        converter: (kgs: number) => kgs / ONE_LB_AS_KG,
      },
    ],
  },
  {
    unit: MeasurementUnits.Kilograms,
    converters: [
      {
        from: MeasurementUnits.Pounds,
        converter: (lbs: number) => lbs * ONE_LB_AS_KG,
      },
    ],
  },
];

export const WeightQuestion = ({ ...props }: WeightQuestionProps) => {
  return <GeneralNumericQuestion {...props} converters={weightUnitConverts} />;
};
